import { ASSET_CLASS_DISPLAY_NAMES } from '@/constants/investmentIcons';

/**
 * Consistent formatter for asset class/type display across the app.
 * Prefers centralized display names and falls back to Title Case with underscore replacement.
 */
export function formatAssetClass(assetType?: string | null): string {
  const raw = (assetType || '').toString().trim().toLowerCase();
  if (!raw) return 'Unclassified';
  const mapped = ASSET_CLASS_DISPLAY_NAMES[raw as keyof typeof ASSET_CLASS_DISPLAY_NAMES];
  if (mapped) return mapped;
  // Fallback: Title Case and replace underscores with spaces
  const withoutUnderscore = raw.replace(/_/g, ' ');
  return withoutUnderscore.charAt(0).toUpperCase() + withoutUnderscore.slice(1);
}
